import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative min-h-[75vh] flex items-center justify-center bg-black overflow-hidden px-4 py-14 matrix-rain-bg scanlines" data-id="element-59">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black z-0" data-id="element-60" />

      {/* Decorative glowing orb - Matrix green */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-matrix-green/10 rounded-full blur-[120px] pointer-events-none z-0" data-id="element-61" />

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-63">
          {/* Logo */}
          <motion.img src="https://i.postimg.cc/QdbbLnHt/Diseno-sin-titulo-7-removebg-preview.png" alt="PromptAdsPro Logo" className="h-16 md:h-20 w-auto mx-auto mb-6 drop-shadow-[0_0_15px_rgba(0,255,65,0.4)]" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-64" />

          <div className="w-16 h-px bg-gradient-to-r from-transparent via-matrix-green to-transparent mx-auto mb-4 opacity-70" data-id="element-65" />

          <span className="inline-block py-1 px-3 rounded-full bg-matrix-green/15 text-matrix-green font-mono font-bold text-sm tracking-wider mb-4 uppercase border border-matrix-green/30 shadow-[0_0_15px_rgba(0,255,65,0.2)]" data-id="element-66">
            Atención Media Buyers e Infoproductores
          </span>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 drop-shadow-lg" data-id="element-67">
            Tus creativos se saturan en 3–7 días.{' '}
            <br className="hidden md:block" data-id="element-68" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-matrix-green to-matrix-bright text-glow-green" data-id="element-69">
              Este software te da el sistema
            </span>{' '}
            para sacar el próximo ángulo sin adivinar.
          </h1>

          <p className="font-body text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-70">
            (Y sin copy robótico). Software de ingeniería publicitaria con IA:
            Producí 10 variaciones estratégicas en 30 minutos.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="relative max-w-3xl mx-auto mb-8 rounded-2xl overflow-hidden border border-matrix-green/30 shadow-[0_0_30px_rgba(0,255,65,0.2)] glow-green-sm" data-id="element-71">
            <div className="absolute inset-0 bg-matrix-green/10 mix-blend-overlay pointer-events-none" data-id="element-72" />
            <img src="https://i.postimg.cc/rwbk9zgR/1.webp" alt="Media buyer frustrado analizando métricas" className="w-full h-auto object-cover" data-id="element-73" />
          </motion.div>

          <motion.a href="https://pay.hotmart.com/I104697906M" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
          content_name: 'PromptAdsPro',
          value: 9.9,
          currency: 'USD'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="group relative inline-flex items-center justify-center gap-3 bg-matrix-green hover:bg-matrix-green-dark text-black font-heading font-bold text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(0,255,65,0.4)] transition-all duration-300 overflow-hidden pulse-glow" data-id="element-74">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-75" />
            <Download className="w-7 h-7 relative z-10 animate-bounce" data-id="element-76" />
            <span className="relative z-10" data-id="element-77">Quiero el Software</span>
          </motion.a>

          <p className="mt-4 text-gray-400 text-sm font-body flex items-center justify-center gap-2" data-id="element-78">
            <span className="w-2 h-2 rounded-full bg-matrix-green animate-pulse shadow-[0_0_10px_rgba(0,255,65,0.5)]" data-id="element-79" />
            Acceso inmediato. Sin curva de aprendizaje.
          </p>
        </motion.div>
      </div>
    </section>;
}